module.exports = __webpack_public_path__ + "media/images/tims_logo-e0edaa63de5a7907209be77dd1df5ac2.png";